import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { defaultConsent, getConsent, saveConsent, onOpenCookiePreferences } from "@/lib/consent";
import { CookiePreferencesPanel } from "./CookiePreferencesPanel";

const btnPrimary = "bg-ivory text-ink px-5 py-2.5 text-[10px] tracking-mega font-medium hover:bg-goldtan transition-colors";
const btnGhost = "border hairline-light text-ivory px-5 py-2.5 text-[10px] tracking-mega font-medium hover:bg-charcoal transition-colors";
const ALL = { analytics: true, marketing: true };
const NONE = { analytics: false, marketing: false };

const PanelActions = ({ prefs, finish }) => (
  <>
    <button data-testid="cookie-save-preferences" onClick={() => finish(prefs)} className={btnPrimary}>SALVA PREFERENZE</button>
    <button data-testid="cookie-banner-accept" onClick={() => finish(ALL)} className={btnGhost}>ACCETTA TUTTI</button>
  </>
);

const BannerActions = ({ finish, openPanel }) => (
  <>
    <button data-testid="cookie-banner-accept" onClick={() => finish(ALL)} className={btnPrimary}>ACCETTA</button>
    <button data-testid="cookie-banner-reject" onClick={() => finish(NONE)} className={btnGhost}>RIFIUTA NON NECESSARI</button>
    <button
      data-testid="cookie-banner-preferences"
      onClick={openPanel}
      className="text-ivory/60 px-3 py-2.5 text-[10px] tracking-mega font-medium hover:text-ivory transition-colors underline underline-offset-4"
    >
      PREFERENZE
    </button>
  </>
);

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [panel, setPanel] = useState(false);
  const [prefs, setPrefs] = useState(defaultConsent);

  useEffect(() => {
    const stored = getConsent();
    if (!stored) setVisible(true);
    else setPrefs(stored);
    return onOpenCookiePreferences(() => {
      setPrefs(getConsent() || defaultConsent);
      setPanel(true);
      setVisible(true);
    });
  }, []);

  const finish = (consent) => {
    saveConsent(consent);
    setVisible(false);
    setPanel(false);
  };
  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60] bg-ink text-ivory p-6 border hairline-light shadow-2xl"
        >
          <p className="font-sans-ui text-[10px] tracking-mega text-ivory/40 mb-3">COOKIE & PRIVACY</p>
          <p className="font-sans-ui text-[13px] text-ivory/80 leading-relaxed">
            Utilizziamo cookie per far funzionare il sito e, solo con il tuo consenso, per misurare le nostre
            campagne. Puoi accettare, rifiutare i non necessari o gestire le preferenze.
          </p>

          <AnimatePresence initial={false}>
            {panel && <CookiePreferencesPanel prefs={prefs} onToggle={toggle} />}
          </AnimatePresence>

          <div className="flex flex-wrap gap-2 mt-5">
            {panel ? <PanelActions prefs={prefs} finish={finish} /> : <BannerActions finish={finish} openPanel={() => setPanel(true)} />}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
